module.exports = __webpack_public_path__ + "static/media/ic_reports.22314283.svg";